'use strict';
import * as $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData from "./app.components.-App-Main-Modal$-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_AppMainModal$Data$Custom(title, content, definedAt) {
  this.Lapp_components_AppMainModal$Data$Custom__f_title = null;
  this.Lapp_components_AppMainModal$Data$Custom__f_content = null;
  this.Lapp_components_AppMainModal$Data$Custom__f_definedAt = null;
  this.Lapp_components_AppMainModal$Data$Custom__f_title = title;
  this.Lapp_components_AppMainModal$Data$Custom__f_content = content;
  this.Lapp_components_AppMainModal$Data$Custom__f_definedAt = definedAt;
}
export { $c_Lapp_components_AppMainModal$Data$Custom as $c_Lapp_components_AppMainModal$Data$Custom };
$c_Lapp_components_AppMainModal$Data$Custom.prototype = new $j_app$002ecomponents$002e$002dApp$002dMain$002dModal$0024$002dData.$h_Lapp_components_AppMainModal$Data();
$c_Lapp_components_AppMainModal$Data$Custom.prototype.constructor = $c_Lapp_components_AppMainModal$Data$Custom;
/** @constructor */
function $h_Lapp_components_AppMainModal$Data$Custom() {
}
export { $h_Lapp_components_AppMainModal$Data$Custom as $h_Lapp_components_AppMainModal$Data$Custom };
$h_Lapp_components_AppMainModal$Data$Custom.prototype = $c_Lapp_components_AppMainModal$Data$Custom.prototype;
$c_Lapp_components_AppMainModal$Data$Custom.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1709309230, true);
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_components_AppMainModal$Data$Custom)) {
    var x = this.Lapp_components_AppMainModal$Data$Custom__f_title;
    var x$2 = x$0.Lapp_components_AppMainModal$Data$Custom__f_title;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_components_AppMainModal$Data$Custom__f_content;
      var x$4 = x$0.Lapp_components_AppMainModal$Data$Custom__f_content;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.productPrefix__T = (function() {
  return "Custom";
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_components_AppMainModal$Data$Custom__f_title;
  }
  if ((n === 1)) {
    return this.Lapp_components_AppMainModal$Data$Custom__f_content;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "title";
  }
  if ((n === 1)) {
    return "content";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_components_AppMainModal$Data$Custom.prototype.definedAt__Lframework_sourcecode_DefinedAt = (function() {
  return this.Lapp_components_AppMainModal$Data$Custom__f_definedAt;
});
function $isArrayOf_Lapp_components_AppMainModal$Data$Custom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_components_AppMainModal$Data$Custom)));
}
export { $isArrayOf_Lapp_components_AppMainModal$Data$Custom as $isArrayOf_Lapp_components_AppMainModal$Data$Custom };
var $d_Lapp_components_AppMainModal$Data$Custom = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_components_AppMainModal$Data$Custom, "app.components.AppMainModal$Data$Custom", ({
  Lapp_components_AppMainModal$Data$Custom: 1,
  Lapp_components_AppMainModal$Data: 1,
  Lframework_components_FrameworkMainModal$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_components_AppMainModal$Data$Custom as $d_Lapp_components_AppMainModal$Data$Custom };
//# sourceMappingURL=app.components.-App-Main-Modal$-Data$-Custom.js.map
